import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  CloseButton,
  Overlay,
  OverlayTrigger,
  Popover,
  Tooltip,
} from 'react-bootstrap';
import './styles.scss';
import Modal from 'react-bootstrap/Modal';

const GenericModal = ({ children, title, isModal = true, placement }) => {
  const [show, setShow] = React.useState(false);
  const target = React.useRef(null);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const popover = (
    <Popover id="popover-basic">
      <Popover.Header as="h3">Popover right</Popover.Header>
      <Popover.Body>
        And here's some <strong>amazing</strong> content. It's very engaging.
        right?
      </Popover.Body>
    </Popover>
  );

  return (
    <>
      {isModal ? (
        <div className="modal-container">
          <i className="bi bi-share-fill" onClick={handleShow}></i>
          <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
              <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>{children}</Modal.Body>
          </Modal>
        </div>
      ) : (
        <div className="tooltip-container">
         <Button ref={target} onClick={handleShow} className='btn'>
          <i className="bi bi-share-fill" />
         </Button>
          <Overlay 
            show={show} 
            target={target.current} 
            placement={placement} 
            rootClose
            onHide={() => setShow(false)}
          >
            <Tooltip className='tooltip_sharing'>
              <div>
                <i className="bi bi-x" onClick={handleClose}></i>
              </div>
              {children} 
            </Tooltip>
          </Overlay>
        </div> 
      )}
    </>
  );
};

GenericModal.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
  placement: PropTypes.string,
  isModal: PropTypes.bool,
};

export default GenericModal;
